import { isUriseOnlyUser } from "@/utils/uriseAccess";

export function identifyAmplitudeUser(amplitude, user) {
  const client = amplitude.getInstance();
  client.setUserId(user.id);

  const identify = new amplitude.Identify().set(
    "organizations",
    user.organizationNames || ""
  );
  if (isUriseOnlyUser(user)) {
    // Amplitude displays an absent property as (none); clear any prior value.
    identify.unset("provider");
  } else {
    identify.setOnce("provider", user.provider);
  }
  client.identify(identify);
}
